module.exports = __webpack_public_path__ + "fonts/RenaultLife-Regular.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/fonts/latin-basic/RenaultLife-Regular.ttf
// module id = 345
// module chunks = 0